import { Resources } from '@shared/localizations/Resources';
import { SvgIconType } from '../../../elements/SvgIcon/SvgIconType';
import { createGroupByContextMenuItem } from '../../../elements/Table/Helpers/ContextMenuHelper';
function createMenuItems(params) {
    const items = [
        {
            id: 'export',
            type: 'item',
            icon: SvgIconType.Export,
            text: Resources.getResource('screen.export.contextMenu'),
        },
        {
            id: 'print',
            type: 'item',
            text: Resources.getResource('screen.reports.print'),
        },
        {
            id: 'view',
            type: 'item',
            icon: SvgIconType.ViewGroup,
            text: Resources.getResource('property.View'),
            subitems: [
                {
                    id: 'totals',
                    type: 'item',
                    checked: params.isShowTotals,
                    text: Resources.getResource('panel.menu.ShowTotals'),
                    onClick: params.onShowTotalsClick,
                },
            ],
        },
        {
            id: 'sep',
            type: 'separator',
        },
    ];
    return items;
}
export function createContextMenuItems(params) {
    const items = createMenuItems(params);
    const groupByContextMenuItem = createGroupByContextMenuItem(params.columns, params.groupByColumn, params.onGroupByClick);
    if (groupByContextMenuItem !== null) {
        items.push(groupByContextMenuItem);
    }
    return items;
}
